/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.real-estate\":\"Talo, jossa on puutarha\"}");